import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {


	constructor(
		private authService: AuthenticationService,
		private router: Router,
        private matDialog: MatDialog
	) {}


	intercept( req: HttpRequest<any>, next: HttpHandler ): Observable<HttpEvent<any>> {
		
		// no need for a token when it concerns assets
		if( !req.url.includes( 'http' ) ) return next.handle(req);


		const token = this.authService.getBtoaToken();
		if( !token ) return next.handle(req);
		// console.log( 'authentication.interceptor', token )

		const clonedReq = req.clone( {
			headers: req.headers
				.set( 'Authorization', 'Basic ' + token )
		});

		// console.log( 'INTERCEPT DONE' )
		return next.handle( clonedReq ).pipe(
			catchError( (error, src) => {

				console.log( 'INTERCEPT FINISHED ERROR', error )
				if( error.status == 401 ) {

					console.log( '401 => REDIRECT TO LOGIN PAGE')

					// Ausnahme für den Endpunkt 'api/benutzer/zweifaktor/email'
                    if (req.url.includes('api/benutzer/zweifaktor/email')) {
                        console.log('Ausnahme: Kein Reload für diesen Endpunkt');
                        this.authService.logout();
                        this.matDialog.closeAll();
                        this.router.navigate(['/auth/login']);
                        return of();
                    }

					this.authService.logout();
					this.matDialog.closeAll();
					this.router.navigate( ['/auth/login'] ).then(() => {
                        window.location.reload();
                    });
                    return of();

				}
				else {

					// return next.handle( clonedReq );
					// return of(error);
					// return throwError( () => new Error( error ) );
					return throwError( () => error );

				}
			})
		);
	}
}

